import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import CallController from '../API/CallController';
import '../scss/Catalogs.scss';

interface Category {
  id: number;
  name: string;
  parentCategoryId: number | null;
}

// Namnet på kategorin knappen ska leda till (små bokstäver)
const CATEGORY_NAME = 'leverantör';

const Catalogs: React.FC = () => {
  const [categoryId, setCategoryId] = useState<number | null>(null);

  useEffect(() => {
    fetch(CallController.GetAllCategories)
      .then(res => res.json())
      .then((data: Category[]) => {
        const match = data.find(c => c.name.trim().toLowerCase() === CATEGORY_NAME);
        if (match) setCategoryId(match.id);
      })
      .catch(console.error);
  }, []);

  if (categoryId === null) return null;

  return (
    <section className="catalogs" style={{ backgroundImage: "url('/pizza.jpg')" }}>
      <div className="catalogs__overlay" />
      <div className="catalogs__content">
        <div className="catalogs__text">
          <h2>Våra leverantörer</h2>
          <p>Se kataloger och sortiment från producenterna vi samarbetar med.</p>
        </div>

        <div className="catalogs__links">
          <Link to={`/products/${categoryId}`} className="catalogs__btn">
            Se alla leverantörer
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M5 12h14" />
              <path d="M13 6l6 6-6 6" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Catalogs;